if (!customElements.get('ll-personalization')) {
  customElements.define('ll-personalization', class extends HTMLElement {
    connectedCallback() {
      this.productInfo = this.closest('product-info');
      this.nameFields = this.querySelector('[data-name-fields]');
      this.variantFields = this.querySelector('[data-variant-personalization]');
      this.colorFields = this.querySelector('[data-color-fields]');
      try {
        this.colorCounts = JSON.parse(this.dataset.colorCounts || '{}');
      } catch {
        this.colorCounts = {};
      }
      if (!this.productInfo || (!this.nameFields && !this.variantFields && !this.colorFields)) return;
      this.onChange = () => this.updateNameFields();
      this.productInfo.addEventListener('change', this.onChange);
      this.updateNameFields();
    }
    disconnectedCallback() {
      this.productInfo?.removeEventListener('change', this.onChange);
    }
    updateNameFields() {
      const selected = this.productInfo.querySelectorAll('variant-selects input:checked, variant-selects select');
      const values = Array.from(selected, input => input.value);
      const custom = !this.variantFields || values.includes(this.dataset.personalizationValue);
      if (this.variantFields) {
        this.variantFields.hidden = !custom;
        this.variantFields.querySelectorAll('input, textarea, select').forEach(input => {
          input.disabled = !custom;
        });
      }
      if (this.nameFields) {
        const hasName = values.includes(this.dataset.nameValue);
        this.nameFields.hidden = !hasName;
        this.nameFields.querySelectorAll('textarea').forEach(input => {
          input.disabled = !hasName;
        });
      }
      if (this.colorFields) {
        const hasTwoColors = values.some(value => this.colorCounts[value] === 2);
        this.colorFields.hidden = !hasTwoColors;
        this.colorFields.querySelectorAll('input, textarea, select').forEach(input => {
          input.disabled = !custom || !hasTwoColors;
        });
      }
    }
  });
}

